function debugLocalhost(){
  if (location.host !== 'localhost:3000') return
  $('img').each(function(){
    let $self = $(this)
    let $src = $self.attr('src')
    if ($src) {
      $src = $src.replace('127.0.0.1', 'localhost:3000')
      $self.attr('src', $src)
    }
    let $dataSrc = $self.attr('data-src')
    if ($dataSrc) {
      $dataSrc = $dataSrc.replace('127.0.0.1', 'localhost:3000')
      $self.attr('data-src', $dataSrc)
    }
    let $dataSrcset = $self.attr('data-srcset')
    if ($dataSrcset) {
      $dataSrcset = $dataSrcset.replace('127.0.0.1', 'localhost:3000')
      $self.attr('data-srcset', $dataSrcset)
    }
  })
}
export default debugLocalhost